import React, { useState, useEffect } from "react";
import {InfoCircle} from "react-bootstrap-icons";
import { Button, Card, Col, Form, Row, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactSelect from "react-select/creatable";

const InfoTooltip = ({ text }) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
    <span className="ms-1" style={{ cursor: 'pointer' }}>
      <InfoCircle />
    </span>
  </OverlayTrigger>
);

export default function DataExtract({ ...props }) {
  const {
    studies,
    model,
    setModel,
    intervention,
    setIntervention,
    comparison,
    setComparison,
    outcome,
    setOutcome,
    robType,
    setRobType,
    setParsedData,
    setOutcomeType
  } = props;

  const [isGenerating, setIsGenerating] = useState(false);
  const [isSuggesting, setIsSuggesting] = useState(false);
  const [locked, setLocked] = useState(true);
  const [suggestions, setSuggestions] = useState({
    intervention: [],
    comparator: [],
    outcome: []
  });

  // NEW — spinner context
  const [currentPhase, setCurrentPhase] = useState(null);     // "extract" or "rob"
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!isSuggesting && suggestions) {
      if (suggestions.intervention.length) setIntervention(suggestions.intervention[0]);
      if (suggestions.comparator.length) setComparison(suggestions.comparator[0]);
      if (suggestions.outcome.length) setOutcome(suggestions.outcome[0]);
      setLocked(false);
    }
  }, [isSuggesting]);

  useEffect(() => {
    if (!locked && suggestions) {
      if (!intervention && suggestions.intervention.length) setIntervention(suggestions.intervention[0]);
      if (!comparison && suggestions.comparator.length) setComparison(suggestions.comparator[0]);
      if (!outcome && suggestions.outcome.length) setOutcome(suggestions.outcome[0]);
    }
  }, [suggestions]);

  const handleSuggestICO = async () => {
    if (!studies.length) return;
    setIsSuggesting(true);
    setLocked(true);
    try {
      const texts = studies.map(s => s.files.map(f => f.markdown).join("\n\n"));
      const res = await fetch(`${process.env.REACT_APP_API_URL}/suggest_ico`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ model, studies: texts, max_new_tokens: 1024 })
      });
      const data = await res.json();
      setSuggestions(data);
    } catch (e) {
      console.error("Error fetching ICO suggestions:", e);
    }
    setIsSuggesting(false);
  };

  // const handleGenerate = async () => {
  //   if (!intervention.trim() || !comparison.trim() || !outcome.trim() || !studies.length) return;
  //
  //   setIsGenerating(true);
  //
  //   const allParsed = [];
  //   let detectedOutcomeType = null;
  //
  //   // UPDATED STRUCTURE
  //   const robRows = [];
  //   for (let i = 0; i < studies.length; i++) {
  //     const study = studies[i];
  //     const studyText = study.files.map(f => f.markdown).join("\n\n");
  //
  //     //
  //     // -------------------- FIRST CALL — normal data extraction --------------------
  //     //
  //     setCurrentPhase("extract");
  //     setCurrentIndex(i);
  //
  //     let parsedEntry = {};
  //     let outcomeType = null;
  //
  //     try {
  //       const res = await fetch(`${process.env.REACT_APP_API_URL}/call_llm`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           model,
  //           study_text: studyText,
  //           outcome,
  //           comparator: comparison,
  //           intervention,
  //           max_new_tokens: 1024
  //         })
  //       });
  //
  //       const data = await res.json();
  //       const result = parseDataExtractLLMOutput(data.response || "");
  //       outcomeType = result.outcomeType;
  //       parsedEntry = result.parsedEntry;
  //
  //       if (!detectedOutcomeType && outcomeType) {
  //         detectedOutcomeType = outcomeType;
  //       }
  //     } catch (e) {
  //       parsedEntry = { error: e.message };
  //     }
  //
  //     allParsed.push({
  //       id: study.id,
  //       name: study.name,
  //       ...structuredClone(parsedEntry),
  //       outcome_type: outcomeType
  //     });
  //     console.log('DATA --->', i, study.id)
  //
  //     //
  //     // -------------------- SECOND CALL — Risk of Bias --------------------
  //     //
  //     setCurrentPhase("rob");
  //
  //     try {
  //       const robRes = await fetch(`${process.env.REACT_APP_API_URL}/call_llm`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           model,
  //           study_text: studyText,
  //           outcome,
  //           comparator: comparison,
  //           intervention,
  //           request_type: "rob",
  //           max_new_tokens: 1024
  //         })
  //       });
  //
  //       const robData = await robRes.json();
  //
  //       // USE YOUR NEW PARSER
  //       const { robEntry, thought } = parseRoBLLMOutput(robData.response || "");
  //
  //       // SAVE IT IN THE NEW STRUCTURE
  //       robRows.push({
  //         id: study.id,
  //         values: [...robEntry],   // ["High", "Low", ...]
  //         thought: thought    // reasoning text
  //       });
  //       console.log('ROB --->', i, study.id)
  //
  //     } catch (e) {
  //       robRows.push({
  //         id: study.id,
  //         values: ["Err", "Err", "Err", "Err", "Err"],
  //         thought: ""
  //       });
  //     }
  //   }
  //
  //   setParsedData(allParsed);
  //   setOutcomeType(detectedOutcomeType);
  //
  //   // STORE STRUCTURED ROB OUTPUT
  //   props.setRiskOfBiasMap(robRows);
  //
  //   setIsGenerating(false);
  //   setCurrentPhase(null);
  // };
  const handleGenerate = async () => {
  if (!intervention.trim() || !comparison.trim() || !outcome.trim() || !studies.length) return;

  setIsGenerating(true);

  const allParsed = [];
  const robRows = [];
  let detectedOutcomeType = null;

  for (let i = 0; i < studies.length; i++) {
    const study = studies[i];
    const studyText = study.files.map(f => f.markdown).join("\n\n");

    // Update button/UI
    setCurrentPhase("extract");
    setCurrentIndex(study.name);

    // --- Run the two calls in parallel ---
    const extractPromise = fetch(
      `${process.env.REACT_APP_API_URL}/data_extract`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model,
          study_text: studyText,
          outcome,
          comparator: comparison,
          intervention,
          max_new_tokens: 2048
        })
      }
    );

    const robPromise = fetch(
      `${process.env.REACT_APP_API_URL}/risk_of_bias`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          model,
          study_text: studyText,
          outcome,
          comparator: comparison,
          intervention,
          risk_of_bias_tool: robType,
          max_new_tokens: 2048
        })
      }
    );

    // Wait for both to complete
    const [extractRes, robRes] = await Promise.all([
      extractPromise,
      robPromise
    ]);

    // --- Handle data extraction result ---
    let parsedEntry = {};
    let outcomeType = null;

    try {
      const data = await extractRes.json();
      const parsed = data.parsed || {};

      parsedEntry = parsed.parsedEntry || {};
      outcomeType = parsed.outcomeType || null;

      if (!detectedOutcomeType && outcomeType) {
        detectedOutcomeType = outcomeType;
      }
    } catch (e) {
      parsedEntry = { error: e.message };
    }

    allParsed.push({
      id: study.id,
      name: study.name,
      ...structuredClone(parsedEntry),
      outcome_type: outcomeType
    });

    // --- Handle risk of bias result ---
    try {
      const robData = await robRes.json();
      const parsed = robData.parsed || {};

      console.log(parsed)

      robRows.push({
        id: study.id,
        values: parsed.robEntry || ["Err", "Err", "Err", "Err", "Err"],
        thought: parsed.thought || ""
      });
    } catch (e) {
      robRows.push({
        id: study.id,
        values: ["Err", "Err", "Err", "Err", "Err"],
        thought: ""
      });
    }

    console.log(`Study ${i + 1} processed`);
  }


  // --- Finalize ---
  setParsedData(allParsed);
  setOutcomeType(detectedOutcomeType);
  props.setRiskOfBiasMap(robRows);

  setIsGenerating(false);
  setCurrentPhase(null);
};

  const renderSuggestDropdown = (label, value, onChange, options, placeholder, tooltip) => {
    const hasSuggestions = Array.isArray(options) && options.length > 0;

    const labelContent = (
      <Form.Label>
        {label}
        <InfoTooltip text={tooltip} />
      </Form.Label>
    );

    if (!hasSuggestions) {
      return (
        <Form.Group>
          {labelContent}
          <Form.Control
            type="text"
            disabled={locked}
            value={value}
            onChange={(e) => {
              onChange(e.target.value);
              setLocked(false);
            }}
            placeholder={placeholder}
          />
        </Form.Group>
      );
    }

    const selectOptions = options.map(opt => ({ label: opt, value: opt }));
    const currentValue =
      selectOptions.find(opt => opt.value === value) || (value ? { label: value, value } : null);

    return (
      <Form.Group>
        {labelContent}
        <ReactSelect
          isClearable
          isDisabled={locked}
          options={selectOptions}
          value={currentValue}
          onChange={selectedOption => {
            onChange(selectedOption ? selectedOption.value : "");
            setLocked(false);
          }}
          isValidNewOption={(inputValue) => inputValue.trim().length > 0}
          onCreateOption={inputValue => {
            onChange(inputValue);
            setLocked(false);
          }}
          formatCreateLabel={inputValue => `Create new: "${inputValue}"`}
          placeholder={placeholder}
        />
      </Form.Group>
    );
  };

  return (
    <Card className="p-4 shadow-sm rounded-4 mb-4">
      <h4 className="mb-3">Forest Plot Settings</h4>
      <Form>
    <Row className="mb-3">
      <Col md={3}>
        {renderSuggestDropdown(
          "Intervention",
          intervention,
          setIntervention,
          suggestions.intervention,
          "e.g., Drug A",
          "The treatment or exposure being studied"
        )}
      </Col>

      <Col md={3}>
        {renderSuggestDropdown(
          "Comparator",
          comparison,
          setComparison,
          suggestions.comparator,
          "e.g., Drug B",
          "What the intervention is compared against"
        )}
      </Col>

      <Col md={3}>
        {renderSuggestDropdown(
          "Outcome",
          outcome,
          setOutcome,
          suggestions.outcome,
          "e.g., Change in symptom",
          "The effect or result measured in the study"
        )}
      </Col>

      <Col ms={2}>
        <Form.Group>
          <Form.Label>Model</Form.Label>
          <Form.Select value={model} onChange={e => setModel(e.target.value)}>
            <option>GPT-4</option>
            <option>Mistral-Large-2512</option>
            <option>Claude-Sonnet-4.5</option>
          </Form.Select>
        </Form.Group>
      </Col>

      <Col ms={1}>
        <Form.Group>
          <Form.Label>RoB</Form.Label>
          <Form.Select value={robType} onChange={e => setRobType(e.target.value)}>
            <option>RoB1</option>
            <option>RoB2</option>
            <option>RoB2_Macros</option>
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    <div className="text-center mt-2 mb-3">
      {isSuggesting ? (
        <div className="text-muted">
          <Spinner animation="border" size="sm" className="me-2" />
          Getting suggestions...
        </div>
      ) : (
        <p className="text-muted mb-0">
          Or{" "}
          <span
            onClick={handleSuggestICO}
            className="text-decoration-underline logo-color-txt"
            role="button"
            style={{ cursor: "pointer" }}
          >
            get a suggestion
          </span>
        </p>
      )}
    </div>

    <div className="text-center">
      <Button className="logo-color" onClick={handleGenerate} disabled={isGenerating}>
        {isGenerating ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />

            {currentPhase === "extract" &&
              `Processing Study ${currentIndex}`}
          </>
        ) : (
          "Extract Data"
        )}
      </Button>
    </div>
      </Form>
    </Card>
  );
}

